import { render, staticRenderFns } from "./AdminEditCompany.vue?vue&type=template&id=3dd56151&"
import script from "./AdminEditCompany.vue?vue&type=script&lang=js&"
export * from "./AdminEditCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports